import React from 'react'

export type TimePickerProps = Omit<React.HTMLAttributes<HTMLDivElement>, 'onChange'> & {
  value?: string
  onChange?: (time: string) => void
  options: string[]
}

const TimePicker = React.forwardRef<HTMLDivElement, TimePickerProps>(function (params, ref) {
  const { value, className, onChange, options, ...props } = params
  return (
    <div
      ref={ref}
      className={className}
      {...props}
    >
      {options.map((time, index) => (
        <div
          key={index}
          className={`h-[30px] px-[10px] flex items-center text-xs cursor-pointer hover:bg-[#0000000D] ${time === value ? 'bg-[#0000000D]' : ''}`}
          onClick={() => onChange?.(time)}
        >
          {time}
        </div>
      ))}
    </div>
  )
})

export default TimePicker
